console.debug((new Date).getFullYear() + ' (c) Ilyin Aleksey <alksily[at]outlook[dot]com>');

window.sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

window.proxy = async (url) => {
    let response = await fetch((location.origin.includes('localhost') ? 'http://parser.farm.u4et.ru' : location.origin) + '/proxy.php?url=' + url);
    
    return await response.text();
};

window.prepare_csv = (list, separator) => {
    let output = [];
    
    if (list.length) {
        let buf = [];
        
        for (let column in list[0]) {
            if (column === 'link') continue;
            buf.push(column);
        }
        output.push(buf.join(separator));
        
        for (let item of list) {
            buf = [];
            for (let column in item) {
                let value = item[column];
                if (column === 'link') continue;
                if (column === 'image') value = value.replace(location.origin + '/proxy.php?url=', '');
                buf.push(('' + value).replace(/(?:\r\n|\r|\n)/g, '<br>'));
            }
            output.push(buf.join(separator));
        }
    }
    
    return output.join("\n");
};

window.download = (filename, text) => {
    let element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent("\uFEFF" + text));
        element.setAttribute('download', filename);
        element.style.display = 'none';
    
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
};

//-----------------------------------------------------------------------
// Toast
let autoCloseToast;

window.toastbox = (target, time) => {
    let a = document.getElementById(target);
    closeToastBox()
    setTimeout(() => {a.classList.add('show')}, 100);
    if (time) {
        time = time + 100;
        autoCloseToast = setTimeout(() => {
            closeToastBox()
        }, time);
    }
}
window.closeToastBox = () => {
    document.querySelectorAll('.toast-box').forEach(function (el) {
        el.classList.remove('show')
        clearTimeout(autoCloseToast)
    })
}
//-----------------------------------------------------------------------
